import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import sk from './locales/sk.json'
import en from './locales/en.json'
import de from './locales/de.json'
import pl from './locales/pl.json'
import hu from './locales/hu.json'
import cs from './locales/cs.json'
import uk from './locales/uk.json'

const savedLang = localStorage.getItem('lang') || 'sk'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      sk: { translation: sk },
      en: { translation: en },
      de: { translation: de },
      pl: { translation: pl },
      hu: { translation: hu },
      cs: { translation: cs },
      uk: { translation: uk },
    },
    lng: savedLang,
    fallbackLng: 'sk',
    interpolation: { escapeValue: false },
  })

export default i18n
